import { type DeliveryAddress } from "@koala/sdk";
import { useDispatch } from "react-redux";
import { StyledEditMenu, StyledEditMenuButton } from "./styles";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import meActions from "@/redux/me/actions";

interface Props {
  address: DeliveryAddress;
}

export const StoredAddressOptionsMenu = ({ address }: Props) => {
  const dispatch = useDispatch();

  return (
    <StyledEditMenu>
      {!address.default && (
        <StyledEditMenuButton
          onClick={() => dispatch(meActions.defaultAddress(address?.id ?? 0))}
        >
          <StringAccessor accessor="account.addresses_default_button" />
        </StyledEditMenuButton>
      )}
      <StyledEditMenuButton
        onClick={() => dispatch(meActions.deleteAddress(address?.id ?? 0))}
      >
        <StringAccessor accessor="account.addresses_delete_button" />
      </StyledEditMenuButton>
    </StyledEditMenu>
  );
};
